import * as React from "react";
import classNames from "classnames";
import { EventCalendarTranslations } from "./EventCalendarTranslations.csharp";
import { CardsList } from "../../../Blocks/CardsList/CardsList";
import { CardsListVariant } from "../../../Blocks/CardsList/CardsListVariant.csharp";
import { PictureProfile } from "../../../../ResizedImage/PictureProfile.csharp";
import { useScrollDirection } from "./hooks/useScrollDirection";

export interface EventsListProps {
    eventGroups: any[];
    profile: PictureProfile;
    translations: EventCalendarTranslations;
    loadMore: () => void;
    hasNextPage: boolean;
    isLoading: boolean;
    pageSize: number;
    totalCount: number;
}

export const EventsList = (props: EventsListProps) => {
    const { isNavigationSticky, isNavigationHidden } = useScrollDirection();

    const totalEventsShown = props.eventGroups.reduce((total, group) => {
        return total + (group.items ? group.items.length : 0);
    }, 0);

    const remainingEvents = props.totalCount - totalEventsShown;
    const remainingEventsText = remainingEvents > 0 ? `${remainingEvents} ` : "0";

    return (
        <div className="EventsList">
            {props.eventGroups && props.eventGroups.length > 0 ? (
                <div className="EventsList__groups">
                    {props.eventGroups.map((group, index) => (
                        <div key={group.title || index} className="EventsList__group">
                            {group.title && (
                                <h3
                                    className={classNames("EventsList__groupTitle", {
                                        "nav-sticky": isNavigationSticky,
                                        "nav-hidden": isNavigationHidden,
                                    })}
                                    id={`group-${index}`}
                                >
                                    {group.title}
                                </h3>
                            )}
                            {group.items && group.items.length > 0 ? (
                                <CardsList
                                    className="EventCalendar__list"
                                    defaultProfile={props.profile}
                                    featuredProfile={props.profile}
                                    translations={props.translations.cardsList}
                                    variant={CardsListVariant.List}
                                    animateChildren={true}
                                    model={{
                                        title: "",
                                        cards: group.items,
                                        alwaysExpanded: true,
                                        showFeatured: false,
                                        hideLink: false,
                                    }}
                                />
                            ) : (
                                group.title && (
                                    <div className="EventsList__emptyGroup">{props.translations.noResults}</div>
                                )
                            )}
                        </div>
                    ))}
                </div>
            ) : (
                <div className="EventCalendar__noResultsInfo">{props.translations.noResults}</div>
            )}
            {props.hasNextPage && (
                <button
                    className="EventCalendar__button button--secondary"
                    onClick={props.loadMore}
                    disabled={props.isLoading}
                >
                    {props.translations.showMore} ( {remainingEventsText} )
                </button>
            )}
        </div>
    );
};
